import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityFeatures = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'End-to-End Encryption',
      description: 'Your data is protected with AES-256 encryption'
    },
    {
      icon: 'Lock',
      title: 'Two-Factor Authentication',
      description: 'Optional 2FA for enhanced account security'
    },
    {
      icon: 'Eye',
      title: 'Privacy First',
      description: 'We never share your personal information'
    },
    {
      icon: 'Clock',
      title: 'Session Management',
      description: 'Automatic logout for inactive sessions'
    }
  ];

  return (
    <div className="mt-8 p-6 bg-muted/30 rounded-lg border border-border">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Your Security Matters
        </h3>
        <p className="text-sm text-muted-foreground">
          ServiceWatch implements industry-leading security measures to protect your account and data.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg flex-shrink-0">
              <Icon name={feature?.icon} size={16} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-foreground">
                {feature?.title}
              </h4>
              <p className="text-xs text-muted-foreground mt-1">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Trust Indicators */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="Shield" size={12} />
            <span>SSL Secured</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="CheckCircle" size={12} />
            <span>SOC 2 Compliant</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Lock" size={12} />
            <span>GDPR Ready</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityFeatures;